import { lazy } from "react";
import Loadable from "app/components/Loadable";

const VMRequestList = Loadable(lazy(() => import("./VmRequestMainPage")));
const VMRequestAdd = Loadable(lazy(() => import("./VMRequestAdd")));

const VMRequestRoutes = [
  { path: "/inv/vm-request", element: <VMRequestList /> },
  { path: "/inv/vm-request/:mode/:id", element: <VMRequestAdd /> },
];

export default VMRequestRoutes;
